import React from 'react'
import CollapsibleStep from 'containers/project-creation/create-view/collapsible-step'
import Input from 'containers/project-creation/create-view/input'
import ICSelect from 'containers/project-creation/create-view/select'
import { FastField } from 'formik'
import Button from 'components/controls/button'

const StepOne = (props) => (
  <div>
    <CollapsibleStep {...props} >
      <div className="bp3-form-group showable-box">
        <div className="showable-box-content-container">
          <div className="side-icon">
            <i className="im-ic-interview" />
          </div>
          <div className="showable-box-content">
            <div className="header">Project Information</div>
            <FastField
              name="name"
              render={({ field, form: { errors: { name: error } } }) =>
                <React.Fragment>
                  <Input
                    title="Please provide a name for this project for your reference"
                    placeholder="Enter Project Name"
                    disabled={false}
                    error={props.errors.name}
                    touched={props.touched.name}
                    showErrors={props.showErrors}
                    {...field}
                  />
                </React.Fragment>
              }
            />
            <FastField
              name="topicName"
              render={({ field, form: { errors: { name: error } } }) =>
                <React.Fragment>
                  <Input
                    title="Topic Name"
                    description="(Participant will see this in communications)"
                    placeholder="Enter Topic Name"
                    disabled={false}
                    error={props.errors.topicName}
                    touched={props.touched.topicName}
                    showErrors={props.showErrors}
                    {...field}
                  />
                </React.Fragment>
              }
            />
            <ICSelect
              title="Interview Duration (For all interviews in this project)"
              disabled={false}
              placeholder="Select Duration"
              options={[15, 30, 45, 60, 75, 90, 120, 150].map(value => ({ value, label: `${value} minutes` }))}
              value={props.values.interviewLength}
              onChange={({ value }) => props.setFieldValue('interviewLength', value)}
              onBlur={() => props.setFieldTouched('interviewLength', true)}
              error={props.errors.interviewLength}
              touched={Boolean(props.touched.interviewLength)}
              showErrors={props.showErrors}
              name="interviewLength"
            />
            <div className="smaple-size-container">
              <FastField
                name="sampleSize"
                render={({ field, form: { errors: { name: error } } }) =>
                  <React.Fragment>
                    <Input
                      title="Sample Size"
                      inputType="number"
                      placeholder="Enter Number"
                      touched={props.touched.sampleSize}
                      showErrors={props.showErrors}
                      error={props.errors.sampleSize}
                      {...field}
                    />
                  </React.Fragment>
                }
              />
            </div>
            <div className="line"></div>
            <ICSelect
                    title="Client"
                    searchable={true}
                    disabled={false}
                    placeholder="Select Client"
                    options={props.clientsList.length!==0? props.clientsList.map(value => ({ value: value.accountId, label: value.name })): []}
                    value={props.values.salesForceClientId}
                    onChange={({value}) => props.onClientChange(value)}
                    onBlur={() => props.setFieldTouched('salesForceClientId', true)}
                    error={props.errors.salesForceClientId}
                    touched={Boolean(props.touched.salesForceClientId)}
                    showErrors={props.showErrors}
                    name="salesForceClientId"
                    className="client"
             />
            <ICSelect
                    title="Salesforce Job Number"
                    description="(Must select Client first)"
                    searchable={true}
                    disabled={!props.values.salesForceClientId}
                    placeholder="Select Salesforce Job Number"
                    options={props.salesForceJobNumbersList.map(value => ({ value: value.salesForceProjectId, label: value.salesForceProjectName }))}
                    value={props.values.salesForceJobNumber}
                    onChange={({value}) => props.setFieldValue('salesForceJobNumber', value)}
                    onBlur={() => props.setFieldTouched('salesForceJobNumber', true)}
                    error={props.errors.salesForceJobNumber}
                    touched={Boolean(props.touched.salesForceJobNumber)}
                    showErrors={props.showErrors}
                    name="salesForceJobNumber"
                    className="salesForceJobNumber"
             />
            <div className="surveyId-container" >
              <div className="surveyId-text">
                Survey ID
                {/* <i> (Can be entered later) </i> */}
              </div>
              <FastField
                name="surveyId"
                render={({ field, form: { errors: { name: error } } }) =>
                  <React.Fragment>
                    <Input
                      title="Identifying number from Decipher or other survey application."
                      placeholder="Enter numerical code"
                      disabled={false}
                      touched={props.touched.surveyId}
                      showErrors={props.showErrors}
                      error={props.errors.surveyId}
                      {...field}
                    />
                  </React.Fragment>
                }
              />
            </div>
          </div>
        </div>
      </div>
      <hr />
    </CollapsibleStep>

    <CollapsibleStep {...props} >
      <div className="bp3-form-group showable-box">
        <div className="showable-box-content-container">
          <div className="side-icon">
            <i className="im-cog" />
          </div>
          <div className="showable-box-content">
            <div className="header">Advanced Options</div>
            <div className="postScreeninBuffer-text"> Interview Time Buffer (For all interviews in this project) </div>
            <ICSelect
              title="Select the time allowed between a respondent screening-in and their first available time slot."
              disabled={false}
              placeholder={props.values.postScreeninBuffer}
              options={[2, 4, 6, 8, 12, 18, 24, 48, 72, 96, 120].map(value => ({ value, label: `${value} Hours ${value === 24 ? "(Default)" : value > 24 ? "(" + value / 24 + " Days)" : ""}` }))}
              value={props.values.postScreeninBuffer === "24 Hours (Default)" ? 24 : props.values.postScreeninBuffer}
              onChange={({ value }) => props.setFieldValue('postScreeninBuffer', value)}
              onBlur={() => props.setFieldTouched('postScreeninBuffer', true)}
              name="postScreeninBuffer"
            />
          </div>
        </div>
      </div>
      <hr />
      <div className="project-action-buttons">
        <Button
          disabled={false}
          className="btn-info create-project-button"
          type="submit"
          isLoading={props.submitting}
        >
          Create Project
        </Button>
      </div>
    </CollapsibleStep>
  </div>
)

export default StepOne
